export default __webpack_public_path__ + "static/media/filter.ca1efed9.svg";